export const mockupQuestions = [
  {
    interactionQuestionId: -1,
    questionId: -1,
    eventId: -1,
    type: "INTERACTION_CLIENT",
    forced: false,
    question: {
      questionId: -1,
      eventId: 4,
      type: "Unknown",
      sortOrder: 0,
      requiredMin: 1,
      requiredMax: 1,
      updatedUserId: 1,
      updated: "2020-09-01T09:44:07.057",
      inserted: "2020-03-30T11:30:24.14",
      tag: null,
      presenterType: null,
      quizAnswer: null,
      allowedAnswerCount: null,
      inherit: true,
      personType: null,
      event: null,
      questionLanguage: [],
      questionOption: [],
    },
  },
  {
    interactionQuestionId: -1,
    questionId: -1,
    eventId: -1,
    type: "INTERACTION_CLIENT",
    forced: false,
    question: {
      questionId: -1,
      eventId: 4,
      type: "Text",
      sortOrder: 0,
      requiredMin: 1,
      requiredMax: 1,
      updatedUserId: 1,
      updated: "2020-09-01T09:44:07.057",
      inserted: "2020-03-30T11:30:24.14",
      tag: null,
      presenterType: null,
      quizAnswer: null,
      allowedAnswerCount: null,
      inherit: true,
      personType: null,
      event: null,
      questionLanguage: [
        {
          questionLanguageId: -1,
          questionId: -1,
          languageCode: "swe",
          label: "Ställ en fråga",
          subLabel: "",
          subInput: "",
          updatedUserId: 1,
          updated: "2020-09-01T09:44:07.07",
          inserted: "2020-03-30T11:30:24.14",
        },
        {
          questionLanguageId: -1,
          questionId: -1,
          languageCode: "eng",
          label: "Ask a question",
          subLabel: "",
          subInput: "",
          updatedUserId: 1,
          updated: "2020-09-01T09:44:07.07",
          inserted: "2020-03-30T11:30:24.14",
        },
      ],
      questionOption: [],
    },
  },
  {
    interactionQuestionId: -1,
    questionId: -1,
    eventId: -1,
    type: "INTERACTION_CLIENT",
    forced: false,
    question: {
      questionId: -1,
      eventId: -1,
      type: "Option",
      sortOrder: 0,
      requiredMin: 1,
      requiredMax: 1,
      updatedUserId: 1,
      updated: "2020-09-01T09:44:07.057",
      inserted: "2020-03-30T11:30:24.14",
      tag: null,
      presenterType: null,
      quizAnswer: null,
      allowedAnswerCount: null,
      inherit: true,
      personType: null,
      event: null,
      questionLanguage: [
        {
          questionLanguageId: -1,
          questionId: -1,
          languageCode: "swe",
          label: "Välj ett alternativ",
          subLabel: "",
          subInput: "",
          updatedUserId: 1,
          updated: "2020-09-01T09:44:07.07",
          inserted: "2020-03-30T11:30:24.14",
        },
        {
          questionLanguageId: -1,
          questionId: -1,
          languageCode: "eng",
          label: "Select a option",
          subLabel: "",
          subInput: "",
          updatedUserId: 1,
          updated: "2020-09-01T09:44:07.07",
          inserted: "2020-03-30T11:30:24.14",
        },
      ],
      questionOption: [
        {
          questionOptionId: -1,
          questionId: -1,
          sortOrder: 1,
          updatedUserId: 1,
          updated: "2020-09-01T09:44:07.11",
          inserted: "2020-03-30T11:31:29.89",
          questionOptionLanguage: [
            {
              questionOptionLanguageId: -1,
              questionOptionId: -1,
              languageCode: "swe",
              label: "Päron",
              updatedUserId: 2,
              updated: "2020-03-30T11:31:29.89",
              inserted: "2020-03-30T11:31:29.89",
            },
            {
              questionOptionLanguageId: -1,
              questionOptionId: -1,
              languageCode: "eng",
              label: "Pear",
              updatedUserId: 2,
              updated: "2020-03-30T11:31:29.89",
              inserted: "2020-03-30T11:31:29.89",
            },
          ],
        },
        {
          questionOptionId: -1,
          questionId: -1,
          sortOrder: 2,
          updatedUserId: 1,
          updated: "2020-09-01T09:44:07.11",
          inserted: "2020-03-30T11:31:29.89",
          questionOptionLanguage: [
            {
              questionOptionLanguageId: -1,
              questionOptionId: -1,
              languageCode: "swe",
              label: "Äpple",
              updatedUserId: 2,
              updated: "2020-03-30T11:31:29.89",
              inserted: "2020-03-30T11:31:29.89",
            },
            {
              questionOptionLanguageId: -1,
              questionOptionId: -1,
              languageCode: "eng",
              label: "Apple",
              updatedUserId: 2,
              updated: "2020-03-30T11:31:29.89",
              inserted: "2020-03-30T11:31:29.89",
            },
          ],
        },
      ],
    },
  },
];
